import React, { useCallback, useState, useEffect } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import useThemeColor from "../../../hooks/useThemeColor";
import { useSelector } from "react-redux";
import axiosInstance from "../../../config/axiosApi/axiosApi";
import APIs from "../../../Constants/apis";
import SupplierModal from "./SupplierModal";

const SupplierSelector = ({
  selectedSupplier,
  setSelectedSupplier,
  showModal,
  setShowModal,
  setLoading,
}) => {
  const [suppliers, setSuppliers] = useState([]);
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(false);
  const isDarkMode = useDarkMode();
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;
  const CompID = useSelector((state) => state.auth.user).userData?.compID;

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  const fetchSuppliers = useCallback(async () => {
    if (!CompID) return;

    try {
      setIsLoadingSuppliers(true);
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_ALL_SUPPLIERS_BY_COMPANY, {
        params: {
          CompID,
        },
      });

      const supplierData = response.data.data || response.data;
      console.log(supplierData);
      if (Array.isArray(supplierData)) {
        setSuppliers(supplierData);
      } else {
        setSuppliers([]);
      }
    } catch (err) {
      console.error("Error fetching suppliers:", err);
      setSuppliers([]);
    } finally {
      setIsLoadingSuppliers(false);
      setLoading(false);
    }
  }, [CompID, setLoading]);

  const handleModalSubmit = (selected) => {
    setSelectedSupplier(selected);
    setShowModal(false);
  };

  return (
    <>
      <div className="mt-3">
        {selectedSupplier ? (
 
          <>
            <div className="row row-cols-1 row-cols-md-2 g-3">
              <div className="col">
                <div
                  className="supplier-chip"
                  style={{
                    background: isDarkMode ? '#404040' : '#ffffff',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    border: isDarkMode ? '2px solid #555' : '2px solid #e9ecef',
                    transition: 'all 0.2s ease',
                    cursor: 'default',
                    position: 'relative',
                    boxShadow: isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.05)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#007bff';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 123, 255, 0.15)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = isDarkMode ? '#555' : '#e9ecef';
                    e.currentTarget.style.boxShadow = isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.05)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      {/* Supplier Icon */}
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          background: isDarkMode ? '#555' : '#f8f9fa',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '12px',
                          border: isDarkMode ? '1px solid #666' : '1px solid #e9ecef'
                        }}
                      >
                        <i className="fa fa-truck" style={{ fontSize: '14px', color: isDarkMode ? '#ffffff' : '#6c757d' }}></i>
                      </div>

                      {/* Supplier Name */}
                      <div>
                        <span
                          style={{
                            fontSize: '15px',
                            fontWeight: '500',
                            color: isDarkMode ? '#ffffff' : '#495057'
                          }}
                        >
                          {selectedSupplier.s_Name || 'Unknown Supplier'}
                        </span>
                        {selectedSupplier.s_Email && (
                          <div style={{
                            fontSize: '12px',
                            color: isDarkMode ? '#adb5bd' : '#6c757d',
                            marginTop: '2px'
                          }}>
                            {selectedSupplier.s_Email}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Remove Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedSupplier(null);
                      }}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        borderRadius: '6px',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        color: '#dc3545'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = isDarkMode ? '#4a1a1a' : '#f8d7da';
                        e.currentTarget.style.color = isDarkMode ? '#ff6b6b' : '#721c24';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = '#dc3545';
                      }}
                    >
                      <i
                        className="fa fa-times"
                        style={{
                          fontSize: '12px'
                        }}
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-4">
              <button
                onClick={() => setShowModal(true)}
                style={{
                  background: themeColor,
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = themeColor + 'dd';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = themeColor;
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i className="fa-solid fa-edit" style={{ fontSize: '12px' }}></i>
                Change Supplier
              </button>
            </div>
          </>
        ) : (
          <div className="text-center py-4">
            <div
              style={{
                width: '60px',
                height: '60px',
                background: isDarkMode ? '#555' : '#f8f9fa',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                border: isDarkMode ? '1px solid #666' : '1px solid #e9ecef'
              }}
            >
              <i className="fa fa-truck" style={{ fontSize: '24px', color: isDarkMode ? '#ffffff' : '#6c757d' }}></i>
            </div>
            <p style={{ color: isDarkMode ? '#ffffff' : '#6c757d', fontSize: '15px', marginBottom: '20px' }}>No Supplier selected</p>
            <button
              onClick={() => setShowModal(true)}
              style={{
                background: themeColor,
                border: 'none',
                borderRadius: '8px',
                padding: '10px 20px',
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                margin: '0 auto'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = themeColor + 'dd';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = themeColor;
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <i className="fa-solid fa-plus" style={{ fontSize: '12px' }}></i>
              Choose Supplier
            </button>
          </div>
        )}
      </div>

      <SupplierModal
        showSupplierModal={showModal}
        setShowSupplierModal={setShowModal}
        showButton={true}
        setSelectedSupplier={setSelectedSupplier}
        selectedSupplier={selectedSupplier}
        onSubmit={handleModalSubmit}
        suppliers={suppliers}
        modalTitle="Select Supplier"
        modalSubTitle="Select a supplier for the purchase order"
        fetchSuppliers={fetchSuppliers}
        isLoadingSuppliers={isLoadingSuppliers}
      />
    </>
  );
};

export default SupplierSelector;